import React, { useState, useRef, useEffect, useCallback } from "react";
import { Button } from "@zendeskgarden/react-buttons";
import { Field as DropdownFeild } from "@zendeskgarden/react-dropdowns";
import { Toggle, Field, Input, Range } from "@zendeskgarden/react-forms";
import { Modal } from "@zendeskgarden/react-modals";
import { toast } from "react-toastify";

import { pick } from "lodash";
import BackendApi from "api/backendApi";

import ReactQuill from "react-quill";
import RenderInlineNotification from "components/RenderInlineNotification";
import { deepClone } from "utils/tools";

export default function EditTemplate({ toggleEditModal, editTemplateItem, setFilterParams }) {
  const [editData, setEditData] = useState(editTemplateItem);

  const [validList, setValidList] = useState({
    tag: false,
    message: false,
  });
  const [quillValue, setQuillValue] = useState("");
  const [toggleActive, setToggleActive] = useState(false);
  const [toggleSaveBtn, setToggleSaveBtn] = useState(false);
  const [loading, setLoading] = useState(false);

  const quillRef = useRef(null);

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
      ["link"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  const handleValid = (tag, tagToZD, quillValue) => {
    const validListTmp = deepClone(validList);
    if (!tag && tagToZD == 0) {
      validListTmp["tag"] = true;
    } else if (!tag && tagToZD == 1) {
      validListTmp["tag"] = false;
    } else {
      validListTmp["tag"] = /^[A-Za-z0-9_]+$/.test(tag);
    }
    validListTmp["message"] = quillValue.length > 0;
    setValidList(validListTmp);
    const validListTmpValues = Object.values(validListTmp);
    const flag = validListTmpValues.findIndex((item) => {
      return item === false;
    });
    setToggleSaveBtn(flag !== -1);
  };

  const handleChange = (e, type, attrKey) => {
    const editDataTmp = JSON.parse(JSON.stringify(editData));
    let obj = {};
    let value = e.target.value;
    if (type === "toggle") {
      value = e.target.checked ? 1 : 0;
      if (attrKey === "template_status" && value == 0) {
        editDataTmp.auto_reply = 0;
      }
    } else {
      obj = { ...editDataTmp, [attrKey]: value };
    }
    obj = { ...editDataTmp, [attrKey]: value };
    setEditData(obj);
    handleValid(
      obj.tag,
      obj.tag_to_zd,
      quillRef.current
        .getEditor()
        .getText()
        .trim(),
    );
    // setToggleSaveBtn(!handleToggleSaveBtn(newValidList) && flag);
  };

  const handleSave = () => {
    const editDataTmp = deepClone(editData);
    const pickEditParams = pick(editDataTmp, ["tag"]);

    Object.keys(pickEditParams).forEach((key) => {
      if (key == "tag") {
        pickEditParams[key] = !!pickEditParams[key] && !/^[A-Za-z0-9_]+$/.test(pickEditParams[key]);
      }
    });
    const valuesDem = Object.values(pickEditParams);
    const flagIndexDem = valuesDem.findIndex((item) => {
      return item === true;
    });
    if (flagIndexDem !== -1) {
      setValidList({ ...validList, ...pickEditParams });
      return { flag: false, params: editDataTmp };
    } else {
      return { flag: true, params: editDataTmp };
    }
  };
  const toastTR = (message = "", type = "success", title) => {
    toast(<RenderInlineNotification message={message} type={type} title={title} />, {
      containerId: "main",
    });
  };
  const handleSaveTemplate = () => {
    const { flag, params } = handleSave();
    const paramsTmp = JSON.parse(JSON.stringify(params));
    const quill = quillRef.current.getEditor();
    const quillValue = quill.root.innerHTML;
    paramsTmp.message = quillValue;
    if (!flag) {
      return false;
    }
    setLoading(true);
    return BackendApi.saveTemplate(paramsTmp)
      .then((res) => {
        if (res.status === "Success") {
          setLoading(false);
          toastTR("You have successfully saved your template.", "success", "Success saved");
          setFilterParams((prevParams) => ({ ...prevParams }));
          toggleEditModal();
        }
        return false;
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setEditData(editTemplateItem);
    setQuillValue(editTemplateItem.message);
    setToggleSaveBtn(!editTemplateItem.message.trim().length > 0);
    setToggleActive(!editTemplateItem.message.trim().length > 0);
    //
    handleValid(
      editTemplateItem.tag,
      editTemplateItem.tag_to_zd,
      editTemplateItem.message ? editTemplateItem.message : "",
    );
  }, []);

  return (
    <>
      <Modal style={{ width: "600px" }} onClose={toggleEditModal}>
        <Modal.Header tag="h2">Edit Template - {editTemplateItem.intent_label}</Modal.Header>
        <Modal.Body>
          <DropdownFeild>
            <DropdownFeild.Label>Additional Tag</DropdownFeild.Label>
            <DropdownFeild.Hint>Text_spaces_will_look_like_this</DropdownFeild.Hint>
            <Input
              placeholder="Example_Tag"
              onChange={(e) => handleChange(e, "input", "tag")}
              value={editData.tag}
              validation={!validList["tag"] && editData.tag_to_zd == 1 ? "error" : ""}
            />
            {!validList["tag"] && (
              <Field.Message validation="error">Only letters, numbers, and underscores are allowed.</Field.Message>
            )}
          </DropdownFeild>
          <div className="flex justify-between mt-[40px]">
            <Field>
              <Field.Label>Tag to Zendesk</Field.Label>
              <Field.Hint>Adds tag to Zendesk ticket</Field.Hint>
            </Field>
            <Field
              onChange={(e) => {
                handleChange(e, "toggle", "tag_to_zd");
              }}
            >
              <Toggle
                checked={editData.tag_to_zd == 1}
                disabled={!editData.tag || editData.tag.length == 0 || !validList["tag"]}
              >
                <Field.Label hidden> 1</Field.Label>
              </Toggle>
            </Field>
          </div>
          <div className="flex justify-between mt-[40px]">
            <Field>
              <Field.Label>Allow Auto Reply</Field.Label>
              <Field.Hint>Turned {editData.auto_reply == 1 ? "On" : "Off"} (Only activate template is on)</Field.Hint>
            </Field>
            <Field
              onChange={(e) => {
                handleChange(e, "toggle", "auto_reply");
              }}
            >
              <Toggle checked={editData.auto_reply == 1} disabled={editData.template_status == 0}>
                <Field.Label hidden> 1</Field.Label>
              </Toggle>
            </Field>
          </div>
          <div className="mt-[40px]">
            <Field
              style={{ width: "55%" }}
              onChange={(e) => {
                handleChange(e, "range", "confidence_score");
              }}
            >
              <Field.Label>Select your confidence score</Field.Label>
              <Field.Hint>Selected: {editData.confidence_score}</Field.Hint>
              <Range step={0.02} min={0.01} max={0.99} value={editData.confidence_score} />
            </Field>
          </div>
          <div className="mt-[40px] ">
            <Field>
              <Field.Label>Auto Reply Content (Required)</Field.Label>
              <div className="mt-[8px]">
                <ReactQuill
                  ref={quillRef}
                  theme="snow"
                  value={quillValue}
                  onChange={(e) => {
                    setQuillValue(e);
                    if (quillRef.current != null) {
                      const flag =
                        quillRef.current
                          .getEditor()
                          .getText()
                          .trim().length > 0;
                      setToggleActive(!flag);
                      handleValid(
                        editData.tag,
                        editData.tag_to_zd,
                        quillRef.current
                          .getEditor()
                          .getText()
                          .trim(),
                      );
                      if (!flag) {
                        setEditData({ ...editData, template_status: 0, auto_reply: 0 });
                      }
                    }
                  }}
                  modules={modules}
                  formats={formats}
                />
              </div>
            </Field>
          </div>
          <div className="flex justify-between mt-[40px]">
            <Field>
              <Field.Label>Activate Template</Field.Label>
              <Field.Hint>Turned {editData.template_status == 1 ? "On" : "Off"}</Field.Hint>
            </Field>
            <Field
              onChange={(e) => {
                handleChange(e, "toggle", "template_status");
              }}
              value={editData.template_status}
            >
              <Toggle checked={editData.template_status == 1} disabled={toggleActive}>
                <Field.Label hidden> 1</Field.Label>
              </Toggle>
            </Field>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Modal.FooterItem>
            <Button
              onClick={() => {
                toggleEditModal();
              }}
              isBasic
            >
              Cancel
            </Button>
          </Modal.FooterItem>
          <Modal.FooterItem>
            <Button isPrimary disabled={toggleSaveBtn || loading} onClick={handleSaveTemplate}>
              Save
            </Button>
          </Modal.FooterItem>
        </Modal.Footer>
        <Modal.Close aria-label="Close modal" />
      </Modal>
    </>
  );
}
